import { defineComponent as _defineComponent } from 'vue'
import type { ReviewVentureStatusKey } from '~/functions/review'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressChips',
  props: {
    counts: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})